module.exports = __webpack_public_path__ + "media/images/emblems/Falera_wappen-6a18c8d2ca7b479895bc71b1b65fbd36.svg";